// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__P_yBB","list":"styles_list__IG5Sk","listItem":"styles_listItem__i7UjS"};